import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { FUB_COMMON_STATUS } from '@beef/elk-common/constants';
import { YMMetricHelper, createMetric } from '@beef/metric';
import { ANALYTICS_ACTION, ANALYTICS_ITEM_TYPE, ANALYTICS_OBJECT_TYPE } from "../../components/Container/ConnectionBlock/constants/analytics";
export var FubMetric = /*#__PURE__*/function (_YMMetricHelper) {
  function FubMetric() {
    var _this;
    _classCallCheck(this, FubMetric);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, FubMetric, [].concat(args));
    _defineProperty(_this, "FUB_PARAMS_KEY", 'fub_profile');
    _defineProperty(_this, "setFub", function (params) {
      return _defineProperty({}, _this.FUB_PARAMS_KEY, _objectSpread({
        page_title: document.title,
        page_url: window.location.href,
        page_path: window.location.pathname
      }, params));
    });
    return _this;
  }
  _inherits(FubMetric, _YMMetricHelper);
  return _createClass(FubMetric, [{
    key: "handleAllBalancesClick",
    value: /** Клик для получения всех балансов */
    function handleAllBalancesClick(data) {
      var _parsedData$userType;
      var parsedData = JSON.parse(data);
      this.sendParamsEvent(this.setFub({
        account_type: parsedData === null || parsedData === void 0 || (_parsedData$userType = parsedData.userType) === null || _parsedData$userType === void 0 ? void 0 : _parsedData$userType.toLowerCase(),
        action: ANALYTICS_ACTION.CLICK,
        item_type: ANALYTICS_ITEM_TYPE.BUTTON,
        button_text: parsedData === null || parsedData === void 0 ? void 0 : parsedData.mainBalanceName,
        button_name: 'выбор_баланса',
        object_type: ANALYTICS_OBJECT_TYPE.WIDGET,
        widget_name: 'balance'
      }));
    }

    /** Клик по кнопке Пополнить */
  }, {
    key: "handlePaymentClick",
    value: function handlePaymentClick(data) {
      var _parsedData$userType2;
      var parsedData = JSON.parse(data);
      this.sendParamsEvent(this.setFub({
        account_type: parsedData === null || parsedData === void 0 || (_parsedData$userType2 = parsedData.userType) === null || _parsedData$userType2 === void 0 ? void 0 : _parsedData$userType2.toLowerCase(),
        action: ANALYTICS_ACTION.CLICK,
        item_type: ANALYTICS_ITEM_TYPE.BUTTON,
        button_text: 'пополнить'
      }));
    }

    /** Клик по кнопке Пополнить тариф */
  }, {
    key: "handleAddTrafficClick",
    value: function handleAddTrafficClick(data) {
      var _parsedData$userType3;
      var parsedData = JSON.parse(data);
      this.sendParamsEvent(this.setFub({
        account_type: parsedData === null || parsedData === void 0 || (_parsedData$userType3 = parsedData.userType) === null || _parsedData$userType3 === void 0 ? void 0 : _parsedData$userType3.toLowerCase(),
        action: ANALYTICS_ACTION.CLICK,
        item_type: ANALYTICS_ITEM_TYPE.ICON,
        icon_type: 'plus',
        icon_name: 'internet'
      }));
    }

    /** Клик по кнопке Настроить тариф */
  }, {
    key: "handleManageTariffClick",
    value: function handleManageTariffClick(data) {
      var _parsedData$userType4;
      var parsedData = JSON.parse(data);
      this.sendParamsEvent(this.setFub({
        account_type: parsedData === null || parsedData === void 0 || (_parsedData$userType4 = parsedData.userType) === null || _parsedData$userType4 === void 0 ? void 0 : _parsedData$userType4.toLowerCase(),
        action: ANALYTICS_ACTION.CLICK,
        item_type: ANALYTICS_ITEM_TYPE.BUTTON,
        button_text: parsedData === null || parsedData === void 0 ? void 0 : parsedData.btnTitle
      }));
    }

    /** Клик по виджету Группы */
  }, {
    key: "handleGroupClick",
    value: function handleGroupClick(data) {
      var _JSON$parse = JSON.parse(data),
        userType = _JSON$parse.userType,
        title = _JSON$parse.title,
        fubStatus = _JSON$parse.fubStatus,
        fubMembersCount = _JSON$parse.fubMembersCount;
      var commonParams = {
        account_type: userType === null || userType === void 0 ? void 0 : userType.toLowerCase(),
        action: ANALYTICS_ACTION.CLICK,
        item_type: ANALYTICS_ITEM_TYPE.BANNER,
        banner_name: 'fub_group',
        banner_text: title,
        user_status: fubStatus
      };
      var params = fubStatus === FUB_COMMON_STATUS.MASTER ? _objectSpread(_objectSpread({}, commonParams), {}, {
        account_count: fubMembersCount
      }) : _objectSpread({}, commonParams);
      this.sendParamsEvent(this.setFub(params));
    }

    /** Клик по тарифу */
  }, {
    key: "handleTariffClick",
    value: function handleTariffClick(data) {
      var _JSON$parse2 = JSON.parse(data),
        userType = _JSON$parse2.userType;
      this.sendParamsEvent(this.setFub({
        account_type: userType === null || userType === void 0 ? void 0 : userType.toLowerCase(),
        action: ANALYTICS_ACTION.CLICK,
        item_type: ANALYTICS_OBJECT_TYPE.WIDGET,
        widget_name: 'tariff'
      }));
    }

    /** Смена тарифа в шторке */
  }, {
    key: "handleBalanceChangeClick",
    value: function handleBalanceChangeClick(data) {
      var _parsedData$userType5;
      var parsedData = JSON.parse(data);
      this.sendParamsEvent(this.setFub({
        account_type: (_parsedData$userType5 = parsedData.userType) === null || _parsedData$userType5 === void 0 ? void 0 : _parsedData$userType5.toLowerCase(),
        action: ANALYTICS_ACTION.CLICK,
        item_type: ANALYTICS_ITEM_TYPE.RADIOBUTTON,
        radiobutton_item_name: parsedData.balanceName,
        object_type: ANALYTICS_OBJECT_TYPE.POPUP,
        popup_name: 'balance'
      }));
    }
  }, {
    key: "handleOrangeComboClick",
    value: function handleOrangeComboClick(data) {
      this.sendParamsEvent(this.setFub({
        account_type: data,
        action: 'click',
        item_type: 'banner',
        banner_name: 'апельсиновое_комбо'
      }));
    }
  }, {
    key: "handleOrangeComboModalView",
    value: function handleOrangeComboModalView(data) {
      this.sendParamsEvent(this.setFub({
        account_type: data,
        action: 'view',
        item_type: 'popup',
        popup_name: 'QR_апельсиновое_комбо'
      }));
    }
  }, {
    key: "handleUnlimAccumulatorTextView",
    value: function handleUnlimAccumulatorTextView(data) {
      var _parsedData$userType6;
      var parsedData = JSON.parse(data);
      var optionSpeed = parsedData === null || parsedData === void 0 ? void 0 : parsedData.optionSpeed;
      this.sendParamsEvent(this.setFub({
        account_type: parsedData === null || parsedData === void 0 || (_parsedData$userType6 = parsedData.userType) === null || _parsedData$userType6 === void 0 ? void 0 : _parsedData$userType6.toLowerCase(),
        action: 'view',
        item_type: 'element',
        option_speed: optionSpeed,
        element_name: parsedData === null || parsedData === void 0 ? void 0 : parsedData.buttonType,
        object_type: 'widget',
        widget_name: 'tariff'
      }));
    }
  }, {
    key: "handleUnlimAccumulatorClick",
    value: function handleUnlimAccumulatorClick(data) {
      var _parsedData$userType7;
      var parsedData = JSON.parse(data);
      var optionSpeed = parsedData === null || parsedData === void 0 ? void 0 : parsedData.optionSpeed;
      var iconName = (parsedData === null || parsedData === void 0 ? void 0 : parsedData.buttonType) === 'Tethering' ? 'Wi-Fi и безлимит' : 'ГБ и безлимит';
      this.sendParamsEvent(this.setFub({
        account_type: parsedData === null || parsedData === void 0 || (_parsedData$userType7 = parsedData.userType) === null || _parsedData$userType7 === void 0 ? void 0 : _parsedData$userType7.toLowerCase(),
        action: 'click',
        item_type: 'icon',
        option_speed: optionSpeed,
        icon_name: iconName,
        object_type: 'widget',
        widget_name: 'tariff'
      }));
    }
  }, {
    key: "handleUnlimAccumulatorView",
    value: function handleUnlimAccumulatorView(data) {
      this.sendParamsEvent(this.setFub({
        account_type: data === null || data === void 0 ? void 0 : data.toLowerCase(),
        action: 'view',
        item_type: 'popup',
        popup_name: 'безлимит на 3 часа'
      }));
    }
  }]);
}(YMMetricHelper);
export var fubMetricSideMenu = new FubMetric({
  counterId: 26001372,
  isEcommerce: false,
  debug: false
});
var _createMetric = createMetric({
    fubMetricSideMenu: fubMetricSideMenu
  }, 'debug'),
  Metric = _createMetric.Metric,
  decorateHandler = _createMetric.decorateHandler,
  withMetricContainer = _createMetric.withMetricContainer,
  withMetricListeners = _createMetric.withMetricListeners;
export { Metric, decorateHandler, withMetricContainer, withMetricListeners };